import React, { useEffect, useState } from "react";
import {
    AppBar,
    Box,
    IconButton,
    makeStyles,
    Tab,
    Tabs,
    Tooltip,
    Typography
} from "@material-ui/core";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import PropTypes from "prop-types";

import { useAppState } from "../application/AppState";
import {
    setAppInit,
    setClaimEvents,
    setCustomer,
    setInsurances,
    setIsAuthenticated,
    setLoading,
    setSelectedClaim
} from "../application/actions";
import { getCustomerData, logOut } from "../application/api";

import Home from "./Home";
import MyInsurances from "./MyInsurances";
import Payments from "./Payments";
import Claims from "./Claims";
import ClaimEvents from "./ClaimEvents";
import QandA from "./QandA";
import Loading from "./Loading";
import useTranslation from "../application/translation";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component="span">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        "aria-controls": `tabpanel-${index}`,
    };
}

const MyPage = () => {
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const translation = useTranslation();

    const [{ loading, appInit }, dispatch] = useAppState();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleLogout = () => {
        logOut();
        dispatch({ type: "resetForms" });
        dispatch(setSelectedClaim(null));
        dispatch(setIsAuthenticated(false));
        window.location.search = "";
    };

    useEffect(() => {
        async function fetchData() {
            if (appInit) {
                dispatch(setLoading(true));
                const data = await getCustomerData();
                dispatch(setCustomer(data?.customer || {}));
                dispatch(setInsurances(data?.customerInsurances || []));
                dispatch(setClaimEvents(data?.claimEvents || []));
                dispatch(setLoading(false));
                dispatch(setAppInit(false));
            }
        }

        fetchData();
    }, []);

    if (loading) {
        return <Loading label={translation.spinner_loading} />;
    }

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs
                    value={value}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={handleChange}
                    aria-label={translation.stepper_header}
                >
                    <Tab label={translation.menu_home} {...a11yProps(0)} />
                    <Tab label={translation.menu_myins} {...a11yProps(1)} />
                    <Tab label={translation.menu_payments} {...a11yProps(2)} />
                    <Tab label={translation.menu_claim} {...a11yProps(3)} />
                    <Tab label={translation.menu_updateclaim} {...a11yProps(4)} />
                    <Tab label={translation.menu_qa} {...a11yProps(5)} />
                  <Tab
                    icon={
                    <Tooltip title={translation.menu_logout} placement="top">
                    <PowerSettingsNewIcon color="secondary" />
                    </Tooltip>
                    }
                    aria-label={translation.menu_logout}
                    onClick={handleLogout}
                        {...a11yProps(6)}
                    />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}><Home /></TabPanel>
            <TabPanel value={value} index={1}><MyInsurances /></TabPanel>
            <TabPanel value={value} index={2}><Payments /></TabPanel>
            <TabPanel value={value} index={3}><Claims /></TabPanel>
            <TabPanel value={value} index={4}><ClaimEvents /></TabPanel>
            <TabPanel value={value} index={5}><QandA /></TabPanel>
        </div>
    );
};

export default MyPage;
